import {
  Outlet,
  Link,
  useLoaderData,
  useNavigate,
  useParams,
  NavLink,
  useLocation
} from "react-router-dom";
import { useState, useEffect } from "react";
import { Resizable } from 're-resizable';
import * as API from "../services/cita";
import {ReactComponent as Logo } from '../img/logo.svg';
import Select from "react-select";

import Navigation from '../components/Navigation';


import FullCalendar, { EventApi, DateSelectArg, EventClickArg, EventContentArg, formatDate } from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import esLocale from '@fullcalendar/core/locales/es';
import { INITIAL_EVENTS, createEventId } from './event-utils.tsx'

import * as APIPACIENTES from "../services/pacientes";
import * as APIESPECIALISTAS from "../services/especialistas";

// import "@fullcalendar/common/main.css";
// import "@fullcalendar/daygrid/main.css";
// import "@fullcalendar/timegrid/main.css";


//import events from "./events";

export async function loader(especialistaId,userRole) {
  let citas;
  if (userRole.includes('administrador')) {
    citas = await API.getCitasByFilters( '', '', '');
  } else {
    citas = await API.getCitasByFilters( '', '', especialistaId);
  }
  return { citas };
}

export default function CalendarList(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const { citas } = useLoaderData();

  const [events, setEvents] = useState(citas);
  const [loadingCalendar, setLoadingCalendar] = useState(false);
  
  
  const [loadingPaciente, setLoadingPaciente] = useState(false);
  const [pacienteQuery, setPacienteQuery] = useState("");
  const [pacienteList, setPacienteList] = useState();
  const [pacienteSelect, setPacienteSelect] = useState([]);
  const [pacienteSelected, setPacienteSelected] = useState([]);
  const [pacienteSelectedString, setPacienteSelectedString] = useState('');
  const [loadingEspecialista, setLoadingEspecialista] = useState(false);
  const [especialistaQuery, setEspecialistaQuery] = useState("");
  const [especialistaList, setEspecialistaList] = useState();
  const [especialistaSelect, setEspecialistaSelect] = useState([]);
  const [especialistaSelected, setEspecialistaSelected] = useState([]);
  const [especialistaSelectedString, setEspecialistaSelectedString] = useState('');

  const [citaTipoSelected, setCitaTipoSelected] = useState([]);
  const [citaTipoSelectedString, setCitaTipoSelectedString] = useState('');

  

  const tratamientoList = {}


  const citaTipoSelect = [
    { value: 'ingreso', label: 'Ingreso' },
    { value: 'valoracion', label: 'Valoracion' },
    { value: 'refuerzo', label: 'Refuerzo' },
    { value: 'consulta-pre-tratamiento-medica', label: 'Consulta Pre-Tratamiento Médica' },
    { value: 'consulta-pre-tratamiento-psicologica', label: 'Consulta Pre-Tratamiento Psicológica' },
    { value: 'visita-medica', label: 'Visita Médica' },
    { value: 'visita-psicologica', label: 'Visita Psicológica' },
    { value: 'consulta-post-tratamiento-psicologica', label: 'Consulta Post-Tratamiento Psicológica' },
    { value: 'psicoterapia', label: 'Sesión Psicoterapia' },
    { value: 'nutricion', label: 'Nutrición' },
    { value: 'entrenamiento', label: 'Entrenamiento' },
    { value: 'mindfulness', label: 'Mindfulness' },
    { value: 'nota', label: 'Nota' },
    { value: 'who5', label: 'Test Who5' },
    { value: 'psqi', label: 'Test PSQI' },
    { value: 'scl90', label: 'Test SCL90' },
  ];

  const initialEvents = citas.map(cita => (
    {
      id: cita.id,
      title: cita.meta?.citaPac?.label || cita.meta?.citaObs || "Nota sin contenido",
      start: cita.meta?.citaFecha + "T" + cita.meta?.citaHora + ":00",
      end: cita.meta?.citaFinFecha + "T" + cita.meta?.citaFinHora + ":00",
    } 
  ));
  // setEvents(initialEvents);

  // 1A. Get list of users (pacientes) by input query set in React Select
  useEffect(() => {
    if (props.userRole.includes('administrador')) {
    const fetchData = async () => {
      setLoadingPaciente(true);
      try {
          await APIPACIENTES.getSearchPacientes(pacienteQuery).then(
            (val) => {
              setPacienteList(val);
            },
            (error) => {
              console.log(error);
            }
          );
      } catch (err) {
        console.log(err);
      }
      setLoadingPaciente(false);
    };

    fetchData();
    }
  }, [pacienteQuery]);

  // 1B. Map all Pacientes to create the options for React Select
  useEffect(() => {
    if (props.userRole.includes('administrador')) {
      let pacienteSelect;
      if (pacienteList) {
        pacienteSelect = pacienteList?.map((field) => ({
          value: field.id,
          label: field.display_name,
        }));
        setPacienteSelect(pacienteSelect);
      }
    }
  }, [pacienteList]);

  // 1C. Map all PacientesValue to create a string with IDs
  useEffect(() => {
    // Utiliza map y join para crear el string con los valores de 'value'
    const nuevoValoresPacientes = pacienteSelected.map(paciente => paciente.value).join(',');
    
    // Actualiza el estado con el nuevo valor
    setPacienteSelectedString(nuevoValoresPacientes);
  }, [pacienteSelected]);

  // 2A. Get list of users (especialistas) by input query set in React Select
  useEffect(() => {
    if (props.userRole.includes('administrador')) {
    const fetchData = async () => {
      setLoadingEspecialista(true);
      try {
          await APIESPECIALISTAS.getSearchEspecialistasAndAdmins(especialistaQuery).then(
            (val) => {
              setEspecialistaList(val);
            },
            (error) => {
              console.log(error);
            }
          );
      } catch (err) {
        console.log(err);
      }
      setLoadingEspecialista(false);
    };

    fetchData();
    }
  }, [especialistaQuery]);

  // 2B. Map all Especialistas to create the options for React Select
  useEffect(() => {
    if (props.userRole.includes('administrador')) {
    let especialistaSelect = especialistaList?.map((field) => ({
        value: field.id,
        label: field.display_name,
      }));
    setEspecialistaSelect(especialistaSelect);
    }
  }, [especialistaList]);

  // 2C. Map all EspecialistasValue to create a string with IDs
  useEffect(() => {
    // Utiliza map y join para crear el string con los valores de 'value'
    const nuevoValoresEspecialistas = especialistaSelected.map(especialista => especialista.value).join(',');
    
    // Actualiza el estado con el nuevo valor
    setEspecialistaSelectedString(nuevoValoresEspecialistas);
  }, [especialistaSelected]);

  // 3C. Map all CitaTipoSelectedString to create a string with comas
  useEffect(() => {
    // Utiliza map y join para crear el string con los valores de 'value'
    const nuevoValoresCitaTipo = citaTipoSelected.map(especialista => especialista.value).join(',');
    
    // Actualiza el estado con el nuevo valor
    setCitaTipoSelectedString(nuevoValoresCitaTipo);
  }, [citaTipoSelected]);

  // 4. Get list of citas regarding new values
  useEffect(() => {
    if (props.userRole.includes('administrador')) {
    const fetchData = async () => {
      setLoadingCalendar(true);
      try {
        console.log(citaTipoSelectedString, pacienteSelectedString, especialistaSelectedString);
        await API.getCitasByFilters(
          citaTipoSelectedString, pacienteSelectedString, especialistaSelectedString
        ).then(
          (val) => {
            setEvents(val);
          },
          (error) => {
            console.log(error);
          }
        );
      } catch (err) {
        console.log(err);
      }
      setLoadingCalendar(false);
    }

    fetchData();
    }
  }, [citaTipoSelectedString, pacienteSelectedString, especialistaSelectedString]);

  let resizableWidth;
  if (props.userRole.includes('administrador')) {
    resizableWidth = 315;
  } else {
    resizableWidth = 130;
  }

  return (
    <>
      <Resizable 
      id="sidebar"
      defaultSize={{
        width: resizableWidth,
      }}
      minHeight="100vh"
      maxHeight="100vh"
      >
      <div className="logo"><Logo /></div>

      {(props.userRole.includes('administrador')) &&

      <nav className="calendarSearchBox">
        <div className='field'>
              <label htmlFor='citaPac'>Paciente</label>
              <div className='control'>
                <Select
                  isMulti
                  className='basic-multi-select'
                  classNamePrefix='select'
                  id='citaPac'
                  name='citaPac'
                  isLoading={loadingPaciente}
                  options={pacienteSelect}
                  placeholder='Seleccionar Paciente'
                  onInputChange={setPacienteQuery}
                  onChange={setPacienteSelected}
                />
              </div>
            </div>

          <div className='field'>
              <label htmlFor='citaEsp'>Especialista</label>
              <div className='control'>
                <Select
                  isMulti
                  className='basic-multi-select'
                  classNamePrefix='select'
                  id='citaEsp'
                  name='citaEsp'
                  isLoading={loadingEspecialista}
                  options={especialistaSelect}
                  placeholder='Seleccionar Especialista'
                  onInputChange={setEspecialistaQuery}
                  onChange={setEspecialistaSelected}
                />
              </div>
            </div>

            <div className='field'>
              <label htmlFor='citaTipo'>Tipo de Cita</label>
              <div className='control'>
                <Select
                  isMulti
                  className='basic-multi-select'
                  classNamePrefix='select'
                  id='citaTipo'
                  name='citaTipo'
                  options={citaTipoSelect}
                  placeholder='Seleccionar Tipo de Cita'
                  onChange={setCitaTipoSelected}
                />
              </div>
            </div>

      </nav>
      }

        {/* other code */}
      </Resizable>
      <main id="main">
        <Navigation {...props} currentUrl={location.pathname} />
        <div id="detail">
          <div id="content" className="calendar">
            <FullCalendar
              locale={esLocale}
              firstDay='1'
              plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
              headerToolbar={{
                left: 'prev,next',
                // left: 'prev,next today',
                center: 'title',
                right: 'dayGridMonth,timeGridWeek,timeGridDay'
              }}
              eventTimeFormat={{
                hour: '2-digit',
                minute: '2-digit',
                meridiem: false
              }}
              initialView='dayGridMonth'
              editable={true}
              selectable={true}
              selectMirror={true}
              dayMaxEvents={true}
              // isLoading={loadingCalendar}

              dateClick={
                function(info) {
                  // navigate(`./cita/new`);
                  navigate('./cita/new', { state: { date: info.dateStr } });
                  // alert('[Pendiente] Crear cita en día: ' + info.dateStr);
                  // alert('Coordenadas en Calendario: ' + info.jsEvent.pageX + ',' + info.jsEvent.pageY);
                  // alert('Vista actual: ' + info.view.type);
                  // change the day's background color just for fun
                  info.dayEl.style.backgroundColor = 'aliceblue';
                  
                }
              }

              eventClick={
                function(arg){
                  navigate(`./cita/${arg.event.id}`);
                }
              }
              
              //weekends={this.state.weekendsVisible}
              initialEvents={initialEvents} // alternatively, use the `events` setting to fetch from a feed
              events={events}
              //select={this.handleDateSelect}
              //eventContent={renderEventContent} // custom render function
              //eventClick={this.handleEventClick}
              //eventsSet={this.handleEvents} // called after events are initialized/added/changed/removed
              /* you can update a remote database when these fire:
              eventAdd={function(){}}
              eventChange={function(){}}
              eventRemove={function(){}}
              */
            />
          </div>
        </div>
      </main>
    </>
  );
}

